import React, { useEffect, useState } from "react";
import "./Bpb.css";
import moment from "moment";
import Select from "react-select";
import { bulan, tahun, BagianConstant } from "../../util/constant";
import { useBpb } from "./useBpb";
import CloseLogo from "../../Assets/close_icon.png";
import TimLama from "../../Assets/tim-lama.jpeg";
import DeleteIcon from "../../Assets/delete_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import {
  formatDot,
  numberWithCommas,
  switchDotsAndCommas,
} from "../../util/utilFunction";
import PdfBpb from "../../components/PdfBpb/PdfBpb";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { generateQRWithLogo } from "../../components/generateQrLogo/qr";

const Bpb = () => {
  const {
    popUpTambah,
    setPopUpTambah,
    errIsEmpty,
    isCheck,
    setIsCheck,
    handleCloseAddBpb,
    isBarang,
    dataListNama,
    isJasa,
    satuan,
    satuanLain,
    setSatuanLain,
    keterangan,
    setKeterangan,
    handleKirimBpb,
    dateBpb,
    setDateBpb,
    handlePickJenisBpb,
    setDariBagian,
    dariBagian,
    setKeBagian,
    keBagian,
    produk,
    setProduk,
    jumlah,
    setJumlah,
    setSatuan,
    dataTempBpb,
    handleDeleteBarangPick,
    handleSubmitBpb,
    setFilterBulan,
    filterBulan,
    setFilterTahun,
    filterTahun,
    listBpb,
    handlePickBpb,
    setIsRefresh,
    dataPick,
    popUpPick,
    setPopUpPick,
    isDisabled,
    setIsDisabled,
  } = useBpb();

  const [qrApprover, setQrApprover] = useState(null);
  const [qrRequestor, setQrRequestor] = useState(null);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      color: "black",
    }),
    control: (provided) => ({
      ...provided,
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };

  useEffect(() => {
    if (dataPick) {
      const approverTemp = dataPick.approver
        ? `${dataPick.approver}, ${moment(dataPick.date)
            .utcOffset("+0700")
            .format("DD-MM-YYYY")}`
        : "";

      const requestorTemp = dataPick.requestor
        ? `${dataPick.requestor}, ${moment(dataPick.date)
            .utcOffset("+0700")
            .format("DD-MM-YYYY")}`
        : "";

      async function createQR() {
        const resultApprover = approverTemp
          ? await generateQRWithLogo(approverTemp)
          : null;

        const resultRequestor = requestorTemp
          ? await generateQRWithLogo(requestorTemp)
          : null;

        setQrApprover(resultApprover);
        setQrRequestor(resultRequestor);
      }

      createQR();
    }
  }, [dataPick]);

  return (
    <>
      {popUpPick ? (
        <PopUpComponent className="wrapper_popup_pick">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <div style={{ display: "flex" }}>
              <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                <b>{dataPick.dari}</b>&nbsp;&nbsp;
              </p>
              <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                {moment(dataPick.date)
                  .utcOffset(7)
                  .format("DD-MM-YYYY, HH:mm:ss")}
              </p>
            </div>

            <div className="font10-mobile-bpb" style={{ padding: "6px" }}>
              <PDFDownloadLink
                document={
                  <PdfBpb
                    data={dataPick}
                    qrApprover={qrApprover}
                    qrRequestor={qrRequestor}
                  />
                }
                fileName={`BPB No.${dataPick.bpbNumber} ${dataPick.dari}.pdf`}
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Loading document..." : "Cetak"
                }
              </PDFDownloadLink>
            </div>

            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => setPopUpPick(false)}
              alt="close_logo"
            />
          </div>
          <div
            style={{
              overflow: "scroll",
              background: "#e5f4d4",
              borderRadius: "8px",
              marginTop: "12px",
            }}
          >
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{ padding: "12px 0 12px 12px", textAlign: "center" }}
                >
                  No.
                </th>
                <th style={{ padding: "12px 0 12px 12px" }}>Item</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Jumlah</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Jenis</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Keterangan</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Status</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Catatan</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Estimasi</th>
                <th style={{ padding: "12px" }}>Realisasi</th>
              </tr>
              {dataPick &&
                dataPick.items.map((ele, index) => (
                  <tr
                    style={
                      !ele.isBeli
                        ? { background: "pink" }
                        : index % 2 === 0
                        ? { background: "white" }
                        : { background: "#F7F7F7" }
                    }
                  >
                    <td
                      style={{
                        padding: "12px 0 12px 12px",
                        textAlign: "center",
                      }}
                    >
                      {index + 1}.
                    </td>
                    <td
                      style={{ padding: "12px 0 12px 12px", textAlign: "left" }}
                    >
                      {ele.item}
                    </td>
                    <td
                      style={{ padding: "12px 0 12px 12px", textAlign: "left" }}
                    >
                      {ele.jumlah ? formatDot(ele.jumlah) : ""}
                    </td>
                    <td
                      style={{ padding: "12px 0 12px 12px", textAlign: "left" }}
                    >
                      {ele.jenis.toUpperCase()}
                    </td>
                    <td
                      style={{ padding: "12px 0 12px 12px", textAlign: "left" }}
                    >
                      {ele.keterangan}
                    </td>
                    <td
                      style={{ padding: "12px 0 12px 12px", textAlign: "left" }}
                    >
                      {ele.isBeli && dataPick.approver
                        ? "Diterima"
                        : !ele.isBeli && dataPick.approver
                        ? "Ditolak"
                        : "Menunggu Approve"}
                    </td>
                    <td style={{ padding: "12px 0 12px 0" }}>{ele.catatan}</td>
                    <td style={{ padding: "12px 0 12px 0" }}>
                      {ele.estimasi
                        ? moment(ele.estimasi)
                            .utcOffset("+0700")
                            .format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td style={{ padding: "12px 0 12px 0" }}>
                      {ele.realisasiDate
                        ? moment(ele.realisasiDate)
                            .utcOffset("+0700")
                            .format("DD-MM-YYYY")
                        : ""}
                    </td>
                  </tr>
                ))}
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpTambah ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90vh",
            width: "88%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => {
                handleCloseAddBpb();
                setIsDisabled(false);
              }}
              alt="edit_logo"
            />
          </div>
          <div className="overflow-container-mobile">
            <div>
              <div className="wrapper-input-bpb">
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Pilih Tanggal
                  </p>
                  <input
                    type="date"
                    className="input-date-bpb"
                    value={dateBpb}
                    onChange={(e) => setDateBpb(e.target.value)}
                  />
                </div>
                <div
                  className={
                    !errIsEmpty
                      ? "checkbox-bpb checkbox-barang-jasa-mobile"
                      : "checkbox-bpb checkbox-barang-jasa-mobile err-empty"
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "6px",
                    }}
                    onClick={() => handlePickJenisBpb("barang")}
                  >
                    <input
                      className="checkbox-barang-jasa"
                      type="checkbox"
                      checked={isBarang}
                    />
                    <label>Barang</label>
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => handlePickJenisBpb("jasa")}
                  >
                    <input
                      className="checkbox-barang-jasa"
                      type="checkbox"
                      checked={isJasa}
                    />
                    <label>Jasa</label>
                  </div>
                </div>
                <div
                  className="checkbox-bpb"
                  onClick={() =>
                    isCheck ? setIsCheck(false) : setIsCheck(true)
                  }
                >
                  <input
                    className="checkbox-barang-jasa"
                    type="checkbox"
                    checked={isCheck}
                  />
                  <label>
                    Nama {isBarang ? "Barang" : isJasa ? "Jasa" : ""} sudah ada
                  </label>
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Dari :
                  </p>
                  <select
                    defaultValue="Dari Bagian :"
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    onChange={(e) => setDariBagian(e.target.value)}
                    value={dariBagian}
                  >
                    <option selected={dariBagian === ""} disabled>
                      Dari Bagian :
                    </option>
                    {BagianConstant.map((obj) => {
                      return <option value={obj.value}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Ke :
                  </p>
                  <select
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    defaultValue="Ke Bagian :"
                    onChange={(e) => setKeBagian(e.target.value)}
                    value={keBagian}
                  >
                    <option selected={keBagian || ""} disabled>
                      Ke Bagian :
                    </option>
                    {BagianConstant.map((obj) => {
                      return <option value={obj.value}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div className="select-barang-bpb">
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Nama Barang
                  </p>

                  {isCheck ? (
                    <Select
                      styles={customStyles}
                      className={
                        !errIsEmpty
                          ? "select-item-bpb"
                          : "select-item-bpb err-empty"
                      }
                      options={
                        isBarang
                          ? dataListNama && dataListNama.listNamaBarang
                          : isJasa
                          ? dataListNama && dataListNama.listNamaJasa
                          : []
                      }
                      value={produk || ""}
                      onChange={setProduk}
                    />
                  ) : (
                    <input
                      className={
                        !errIsEmpty
                          ? "input-date-bpb input-nama-barang-bpb"
                          : "input-date-bpb input-nama-barang-bpb err-empty"
                      }
                      type="text"
                      placeholder="Nama Barang"
                      value={produk ? produk : ""}
                      onChange={(e) => setProduk(e.target.value.toUpperCase())}
                      onWheel={(e) => e.target.blur()}
                    />
                  )}
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Jumlah
                  </p>
                  <input
                    className={
                      !errIsEmpty
                        ? "input-date-bpb"
                        : "input-date-bpb err-empty"
                    }
                    type="number"
                    placeholder="Jumlah"
                    style={{
                      width: "58px",
                      padding: "0 0 0 6px",
                    }}
                    value={jumlah ? jumlah : ""}
                    onChange={(e) => setJumlah(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Satuan
                  </p>
                  <select
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    defaultValue="Satuan"
                    onChange={(e) => setSatuan(e.target.value)}
                    value={satuan}
                  >
                    <option selected={satuan || ""} disabled>
                      Satuan
                    </option>
                    {dataListNama &&
                      dataListNama.listSatuan.map((e) => (
                        <option value={e.value}>{e.label}</option>
                      ))}
                    <option value="LAINNYA">LAINNYA</option>
                  </select>
                </div>
                {satuan === "LAINNYA" ? (
                  <div style={{ marginRight: "6px" }}>
                    <p
                      className="font10-mobile-bpb"
                      style={{ margin: "6px 0" }}
                    >
                      Nama Satuan
                    </p>
                    <input
                      className={
                        !errIsEmpty
                          ? "input-date-bpb"
                          : "input-date-bpb err-empty"
                      }
                      type="text"
                      placeholder="Satuan"
                      style={{
                        padding: "0 0 0 6px",
                      }}
                      value={satuanLain}
                      onChange={(e) =>
                        setSatuanLain(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Keterangan
                  </p>
                  <input
                    className={
                      !errIsEmpty
                        ? "input-date-bpb input-keterangan-bpb"
                        : "input-date-bpb input-keterangan-bpb err-empty"
                    }
                    type="text"
                    placeholder="Keterangan"
                    value={keterangan ? keterangan : ""}
                    onChange={(e) =>
                      setKeterangan(e.target.value.toUpperCase())
                    }
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div
                  className="wrapper-button-tambah-bpb"
                  style={{ marginRight: "6px" }}
                  onClick={() => handleKirimBpb()}
                >
                  <p></p>
                  <button className="button-tambah-bpb font10-mobile-bpb">
                    Tambah
                  </button>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "32px" }}>
              <p className="title-form-bpb">Form-PUR-A3-R2</p>
              <div
                style={{
                  display: "flex",
                  marginBottom: "12px",
                  alignItems: "center",
                }}
              >
                <img src={TimLama} className="img-tim-bpb" />
                <p className="title-bpb">
                  Bon Permintaan Barang dan Jasa (BPB)
                </p>
              </div>
              <div className="wrapper-table-popup-pick">
                <table
                  style={{
                    width: "100%",
                    borderSpacing: 0,
                  }}
                >
                  <tr style={{ color: "white" }}>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 0 12px 4px",
                        background: "#0e5d5a",
                      }}
                    >
                      No.
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                        background: "#0e5d5a",
                      }}
                    >
                      Item
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "center",
                        background: "#0e5d5a",
                      }}
                    >
                      Jumlah
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                        background: "#0e5d5a",
                      }}
                    >
                      Keterangan
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                        background: "#0e5d5a",
                      }}
                    >
                      Jenis
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                        background: "#0e5d5a",
                      }}
                    >
                      Satuan
                    </th>

                    <th
                      style={{
                        borderBottom: "1px solid lightgray",
                        background: "#0e5d5a",
                      }}
                    ></th>
                  </tr>

                  {dataTempBpb &&
                    dataTempBpb.map((data, index) => {
                      return (
                        <tr
                          style={
                            index % 2 === 0
                              ? { background: "#F7F7F7" }
                              : { background: "#f2f2f2" }
                          }
                          key={index}
                        >
                          <td
                            className="number-table-bpb font10-mobile-bpb"
                            style={{ paddingTop: "12px" }}
                          >
                            {index + 1}.
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {data.item}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ textAlign: "center" }}
                          >
                            {formatDot(
                              switchDotsAndCommas(numberWithCommas(data.jumlah))
                            )}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {data.keterangan}
                          </td>
                          <td className="td-table-bpb font10-mobile-bpb">
                            {data.jenis}
                          </td>
                          <td className="td-table-bpb font10-mobile-bpb">
                            {data.satuan}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            onClick={() => handleDeleteBarangPick(data.id)}
                          >
                            <img className="img-delete-bpb" src={DeleteIcon} />
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                className="button-kirim-bpb"
                disabled={isDisabled}
                onClick={() => {
                  setIsDisabled(true);
                  handleSubmitBpb();
                }}
              >
                Kirim
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="container_dashboard">
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <label style={{ fontWeight: "550", fontSize: "18px" }}>
              List BPB
            </label>
            <div
              className="wrapper-button-tambah"
              onClick={() => setPopUpTambah(true)}
            >
              <p className="button-tambah">+</p>
              <button className="text-button-tambah">New BPB</button>
            </div>
          </div>

          <br />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <select
                style={{ marginRight: "6px", marginBottom: "6px" }}
                className="select-filter-bulan-tahun"
                defaultValue="Bulan"
                onChange={(e) => setFilterBulan(e.target.value)}
                value={filterBulan}
              >
                <option selected disabled>
                  Bulan
                </option>
                {bulan.map((ele) => (
                  <option value={Number(ele.value)}>{ele.name}</option>
                ))}
              </select>
              <select
                className="select-filter-bulan-tahun"
                defaultValue="Tahun"
                onChange={(e) => setFilterTahun(e.target.value)}
                style={{ marginRight: "12px" }}
                value={filterTahun}
              >
                <option selected disabled>
                  Tahun
                </option>
                {tahun.map((ele) => (
                  <option value={ele}>{ele}</option>
                ))}
              </select>
              <img
                src={RefreshIcon}
                alt="refresh"
                style={{
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsRefresh(true);
                }}
              />
            </div>
          </div>

          {listBpb && listBpb.length > 0 ? (
            <div
              style={{
                marginTop: "12px",
                background: "#e5f4d4",
                borderRadius: "8px",
                overflow: "scroll",
              }}
            >
              <table
                className="font10-mobile-bpb"
                style={{
                  width: "100%",
                  borderSpacing: 0,
                  textAlign: "left",
                }}
              >
                <tr>
                  <th
                    style={{
                      padding: "8px 0px 8px 24px",
                      width: "10%",
                    }}
                  >
                    No.
                  </th>
                  <th style={{ width: "15%", padding: "8px" }}>Tanggal</th>
                  <th style={{ padding: "8px" }}>No. BPB</th>
                  <th style={{ padding: "8px" }}>Dari</th>
                  <th style={{ padding: "8px" }}>Ke</th>
                  <th style={{ padding: "8px" }}>Status</th>
                </tr>
                {listBpb &&
                  listBpb.map((data, index) => {
                    return (
                      <tr
                        style={
                          index % 2 === 0
                            ? { background: "white", cursor: "pointer" }
                            : { background: "#F7F7F7", cursor: "pointer" }
                        }
                        onClick={() => handlePickBpb(data)}
                      >
                        <td
                          style={{
                            textAlign: "left",
                            padding: "12px 0px 8px 24px",
                          }}
                        >
                          {index + 1}.
                        </td>
                        <td
                          style={{
                            padding: "12px 8px",
                            textAlign: "left",
                          }}
                        >
                          {moment(data.date).utcOffset(7).format("DD-MM-YYYY")}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "left" }}>
                          {data.bpbNumber}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "left" }}>
                          {data.dari}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "left" }}>
                          {data.ke}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "left" }}>
                          {!data.isApprove
                            ? "SEDANG DI REVIEW"
                            : data.isApprove && !data.isProccess
                            ? "SEDANG DI PROSES"
                            : "SELESAI"}
                        </td>
                      </tr>
                    );
                  })}
              </table>
            </div>
          ) : (
            ""
          )}
        </>
      </div>
    </>
  );
};
export default Bpb;
